import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/google-callback`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true,
          }
        );

        toast.success('Login successful!');
        navigate('/', { replace: true, state: { user: response.data.user } });
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Auth callback error:', error);
        }
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-2 border-zinc-300 border-t-[#0033A0] rounded-full animate-spin" />
        <p className="mt-4 text-sm text-zinc-500 font-ibm">Completing authentication...</p>
      </div>
    </div>
  );
};
